import { useIntl } from "react-intl";
import { useCurrentVstLocale } from "../../../common/utils/locale";
import useJigsawUser from "../common/user/useJigsawUser";
import ScrollableComponentTemplate from "../layout/content-templates/scrollable-component/ScrollableComponentTemplate.tsx";

export default function AdminComponent() {
  const jigsawUser = useJigsawUser();
  const vstLocale = useCurrentVstLocale();
  const intl = useIntl();
  const title = intl.formatMessage({ defaultMessage: "Admin" });

  return (
    <ScrollableComponentTemplate title={title}>
      {jigsawUser && (
        <admin-dashboard
          jigsawsessionid={jigsawUser?.user.sessionId}
          lang={vstLocale}
          basename={"/"}
        />
      )}
    </ScrollableComponentTemplate>
  );
}
